<template>
  <div class="rodape-alerta">
    <span class="rodape-alerta__eyebrow">Fique de olho</span>
    <p class="rodape-alerta__titulo">Estava tentando encontrar uma dívida, mas ela não apareceu?</p>
    <p class="rodape-alerta__texto">
      Quando uma nova dívida entrar em nosso sistema, emitiremos um alerta via e-mail ou SMS sobre o débito em
      aberto.
    </p>
  </div>
</template>

<style scoped lang="scss">
@use "@/assets/styles/functions.scss" as *;
@use "@/assets/styles/vars" as *;

.rodape-alerta {
  display: flex;
  flex-direction: column;
  gap: px2rem(8px);
}

.rodape-alerta__eyebrow {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-77, #777);
}

.rodape-alerta__titulo {
  margin: 0;
  font-size: px2rem(13px);
  font-weight: 800;
  color: var(--neutral-00, #131416);
}

.rodape-alerta__texto {
  margin: 0;
  font-size: px2rem(12.5px);
  line-height: 1.55;
  color: var(--neutral-77, #777);
}
</style>
